import { CONFIG } from './config'

export const WORDS = [
  'DAVID',
'JAMES',
'JASON',
'SARAH',
'BRIAN',
'MEGAN',
'KEVIN',
'LAURA',
'AMBER',
'EMILY',
'AARON',
'JACOB',
'JAMIE',
'KELLY',
'TYLER',
'SCOTT',
'ERICA',
'BRYAN',
'JESSE',
'KATIE',
'SHAWN',
'APRIL',
'DEREK',
'JENNA',
'MARIA',
'JARED',
'JULIE',
'PETER',
'HOLLY',
'COREY',
'KEITH',
'SHANE',
'BRETT',
'STACY',
'CRAIG',
'DIANA',
'ERIKA',
'CASEY',
'BRENT',
'FRANK',
'JULIA',
'KAREN',
'LARRY',
'BLAKE',
'RANDY',
'JESUS',
'SUSAN',
'TRACY',
'KAYLA',
'NANCY',
'RENEE',
'MOLLY',
'JERRY',
'MISTY',
'MARIO',
'TERRY',
'LACEY',
'SHAUN',
'DEVIN',
'HEIDI',
'LUCAS',
'JORGE',
'ANDRE',
'ALLEN',
'LANCE',
'CHASE',
'TANYA',
'LINDA',
'BOBBY',
'CALEB',
'KELLI',
'HENRY',
'DANNY',
'ROBIN',
'RICKY',
'JIMMY',
'BILLY',
'JENNY',
'EBONY',
'WENDY',
'ANGEL',
'COLIN',
'ROGER',
'LOUIS',
'ISAAC',
'GRANT',
'TONYA',
'CINDY',
'OSCAR',
'JAIME',
'MARIE',
'TASHA',
'RUBEN',
'SHANA',
'BRUCE',
'CARLA',
'WAYNE',
'HALEY',
'EDWIN',
'DYLAN',
'CARLY',
'AIMEE',
'MANDY',
'PEDRO',
'JANET',
'LYDIA',
'TAMMY',
'NIKKI',
'DONNA',
'DIANE',
'MAYRA',
'EDDIE',
'MICAH',
'TARYN',
'MINDY',
'NAOMI',
'GRACE',
'PAULA',
'ROBYN',
'GLENN',
'LOGAN',
'STEVE',
'RAMON',
'BRYCE',
'TOMMY',
'DEVON',
'ALANA',
'BARRY',
'MARCO',
'DAISY',
'RANDI',
'TYSON',
'ELISE',
'DEBRA',
'BRADY',
'KARLA',
'CESAR',
'BYRON',
'SONIA',
'JULIO',
'EDGAR',
'KASEY',
'KERRI',
'ELLEN',
'CAROL',
'ANNIE',
'ERICK',
'HELEN',
'TRACI',
'SONYA',
'HARRY',
'LEIGH',
'INDIA',
'RALPH',
'STACI',
'ANITA',
'PAIGE',
'ELENA',
'DARYL',
'COLBY',
'TERRI',
'BROCK',
'ALVIN',
'TRENT',
'TESSA',
'ELISA',
'KERRY',
'IRENE',
'ETHAN',
'ALICE',
'ELYSE',
'CLINT',
'JAMAL',
'KATHY',
'CHRIS',
'SANDY',
'ARIEL',
'SASHA',
'JAYME',
'DAMON',
'HEATH',
'TIARA',
'KENNY',
'DUANE',
'SALLY',
'SIMON',
'LEWIS',
'FAITH',
'CIARA',
'LEROY',
'JOYCE',
'LAMAR',
'GAVIN',
'PERRY',
'ALLAN',
'SHARI',
'NADIA',
'BECKY',
'BLAIR',
'BETTY',
'NORMA',
'ALISA',
'AUDRA',
'FELIX',
'NOLAN',
'TERRA',
'SHERI',
'ASHLY',
'PABLO',
'MILES',
'MASON',
'LLOYD',
'JAMAR',
'ANGIE',
'LEANN',
'ELIAS',
'BOBBI',
'JOSUE',
'DARIN',
'ROCKY',
'MANDI',
'CELIA',
'RAVEN',
'TANIA',
'JOANN',
'BETSY',
'DANTE',
'LOREN',
'DONTE',
'LUCIA',
'CATHY',
'ROMAN',
'KYLIE',
'CLARA',
'KACIE',
'JODIE',
'DUSTY',
'CHLOE',
'ROCIO',
'DIEGO',
'TASIA',
'LACIE',
'AISHA',
'TIANA',
'DAYNA',
'JANNA',
'RILEY',
'RUSTY',
'TOMAS',
'TOSHA',
'KOREY',
'MOSES',
'ABBEY',
'TRINA',
'EDITH',
'BRYON',
'JAROD',
'FLOYD',
'SONJA',
'JAMEL',
'SADIE',
'JANIE',
'DARCY',
'KENYA',
'CHERI',
'CLARK',
'NAKIA',
'CLYDE',
'DEANA',
'PENNY',
'TARAH',
'NOEMI',
'MAURA',
'JONAH',
'CECIL',
'MYRON',
'SOFIA',
'DORIS',
'ASHLI',
'HOLLI',
'AVERY',
'GARRY',
'ERICH',
'PEGGY',
'CIERA',
'BRICE',
'SAMMY',
'ELIZA',
'HANNA',
'CANDY',
'RENAE',
'EBONI',
'MARLA',
'WANDA',
'ABBIE',
'TALIA',
'MAGEN',
'ANTON',
'KYLEE',
'KIRBY',
'KACEY',
'JOSIE',
'MARCI',
'LEILA',
'TAMRA',
'JANAE',
'ARRON',
'ROYCE',
'MYLES',
'JEROD',
'BENNY',
'JAIRO',
'WYATT',
'RIKKI',
'CLARE',
'VICKI',
'ALTON',
'CASIE',
'PERLA',
'PARIS',
'MISTI',
'SONNY',
'LYNDA',
'ELVIS',
'JOVAN',
'CONOR',
'ALEXA',
'KALEB',
'VICKY',
'TYREE',
'LUKAS',
'KARIN',
'REYNA',
'NIGEL',
'JONAS',
'ALYSE',
'MARCY',
'BRODY',
'DAVON',
'AHMAD',
'TONIA',
'JERAD',
'JANEL',
'CHANA',
'ALINA',
'KALEY',
'JESSI',
'DELIA',
'HILDA',
'DAVIS',
'KEELY',
'ISSAC',
'PAOLA',
'CANDI',
'DARLA',
'MARTA',
'CAREY',
'WENDI',
'MAIRA',
'DERIK',
'QUINN',
'MAGAN',
'JOSEF',
'KILEY',
'GREGG',
'BRYNN',
'JEANA',
'PEARL',
'SHARA',
'KARLY',
'ALENA',
'VANCE',
'SUSIE',
'SUNNY',
'BROOK',
'BRANT',
'TYREL',
'AKEEM',
'JENNI',
'GALEN',
'DEENA',
'ROBBY',
'KASIE',
'TISHA',
'SHENA',
'MIKEL',
'SHIRA',
'RHETT',
'MARTY',
'IESHA',
'DEVAN',
'BRAIN',
'KIANA',
'CARYN',
'JAVON',
'CARLO',
'KARYN',
'ABRAM',
'TEDDY',
'ELVIA',
'ELANA',
'LINDY',
'JOANA',
'ELLIS',
'MARGO',
'JERED',
'TEENA',
'TIMMY',
'TEELA',
'LIANA',
'JAMIL',
'TAWNY',
'DARCI',
'JAYNE',
'JARON',
'ELMER',
'JUANA',
'ANAIS',
'AFTON',
'LEONA',
'KESHA',
'TITUS',
'SARAI',
'IVORY',
'ROCCO',
'KIERA',
'KARLI',
'GRADY',
'ERVIN',
'CYRUS',
'ALLIE',
'LATIA',
'DULCE',
'MALIA',
'KANDI',
'ISIAH',
'ELSIE',
'DAREN',
'CHAYA',
'TEGAN',
'NICKI',
'KISHA',
'CARLI',
'FIDEL',
'RUFUS',
'KAILA',
'LUISA',
'DANAE',
'TAMAR',
'ADRIA',
'LIDIA',
'DAVIN',
'ELVIN',
'AHMED',
'TYRON',
'SHERA',
'NIKIA',
'MALIK',
'JAMEY',
'CASSI',
'ROSIE',
'LOUIE',
'HAZEL',
'TIERA',
'RONDA',
'LYNNE',
'MOSHE',
'DENNY',
'DALIA',
'SILAS',
'REINA',
'BUDDY',
'STARR',
'LAKIA',
'DONNY',
'MONTE',
'KELSI',
'SANDI',
'LORNA',
'GRETA',
'ERROL',
'DARON',
'ADINA',
'LARON',
'LAKEN',
'JEWEL',
'CORIE',
'CHAIM',
'RAINA',
'CLIFF',
'RAYNA',
'JERRI',
'ALONA',
'LORIE',
'CORAL',
'TYLOR',
'KRAIG',
'KEENA',
'GENNA',
'ANIKA',
'SHANI',
'REGAN',
'TAMMI',
'RYANN',
'GINNY',
'DRAKE',
'DONTA',
'DIXIE',
'DANNA',
'EFREN',
'RONNY',
'JENAE',
'FALON',
'SAMIR',
'MAREN',
'LILIA',
'KIARA',
'DENIS',
'KENNA',
'KARRI',
'KALYN',
'ILANA',
'ELTON',
'VINCE',
'PERCY',
'KEVEN',
'GAYLE',
'ERNIE',
'URIEL',
'MINDI',
'JONNA',
'ERWIN',
'DERON',
'ELIOT',
'ASHER',
'KARIE',
'DARIO',
'CHADD',
'LIBBY',
'IRVIN',
'TRACE',
'TAREN',
'KOLBY',
'JAMEE',
'ROMEO',
'PETRA',
'NISHA',
'KEIRA',
'FIONA',
'REESE',
'JESSY',
'DEVEN',
'CYNDI',
'CAYLA',
'DEANN',
'ALDEN',
'TAKIA',
'KATEY',
'RANDA',
'DERIC',
'DARBY',
'NELLY',
'KALEN',
'JORDY',
'JAKOB',
'KALEE',
'FLORA',
'ALAIN',
'PRIYA',
'MITCH',
'LAYLA',
'KASSI',
'ERINN',
'ELENI',
'BELEN',
'SHALA',
'PATSY',
'KALIE',
'JASEN',
'JARAD',
'JANIS',
'ARICA',
'TARRA',
'MONTY',
'HOMER',
'YOSEF',
'VENUS',
'HIRAM',
'CHELA',
'KEVAN',
'CASSY',
'ANDRA',
'TOREY',
'TALON',
'KADIE',
'GERRY',
'FARAH',
'EMERY',
'ADDIE',
'AMINA',
'NYDIA',
'LACEE',
'KEONA',
'ADELE',
'URIAH',
'TARIN',
'RIVKA',
'PATTY',
'LILLY',
'JAMIN',
'SHYLA',
'KAELA',
'CAREN',
'BARON',
'APRYL',
'VANNA',
'TAVON',
'MIRNA',
'MERYL',
'KAYCE',
'ILENE',
'EBONE',
'BRITT',
'MONET',
'JENEE',
'ALIZA',
'TANNA',
'MYRNA',
'MANDA',
'LAILA',
'KEILA',
'SABRA',
'LYSSA',
'BRIEN',
'ANSON',
'ALYSA',
'REECE',
'LISSA',
'DEWEY',
'BRUNO',
'AGNES',
'MABEL',
'JEREL',
'JAYNA',
'ISELA',
'TERAH',
'ROSIO',
'LAVON',
'KELSY',
'DANIA',
'TARIQ',
'POLLY',
'ORION',
'MISSY',
'KYLER',
'ESTER',
'DEDRA',
'CARIE',
'ALEAH',
'WILEY',
'VIOLA',
'MAILE',
'DINAH',
'DACIA',
'ALISE',
'REYES',
'ENOCH',
'BAMBI',
'AMARA',
'TARIK',
'RENEA',
'PAULO',
'PAOLO',
'NICKY',
'MIKKI',
'KARIS',
'GARTH',
'CODIE',
'AYANA',
'AMIRA',
'ADELA',
'WINDY',
'RAJIV',
'DURAN',
'DOYLE',
'DENAE',
'CARIN',
'ABDUL',
'TERYN',
'TATUM',
'TAINA',
'SOMER',
'SACHA',
'PIPER',
'NYSSA',
'LUCIO',
'ELDON',
'DELLA',
'MOIRA',
'MAURO',
'KARIM',
'JANEE',
'DUSTI',
'DAYNE',
'CHUCK',
'VIDAL',
'TONEY',
'MYKEL',
'LIANE',
'JOVON',
'LEANA',
'KACEE',
'CINDI',
'OMARI',
'MARLO',
'MARKO',
'KATIA',
'ELIDA',
'CORRY',
'CALEN',
'TESHA',
'TAREK',
'RAMEL',
'LEVON',
'LESLI',
'JOLIE',
'CLAIR',
'CALLI',
'AIDAN',
'YUSUF',
'TARAN',
'PILAR',
'MALKA',
'LYNDI',
'LORNE',
'KALLI',
'ETHEL',
'CAMEO',
'AVIVA',
'TRISH',
'TAWNI',
'ROYAL',
'MITZI',
'MICKI',
'MERRY',
'LORIN',
'LENNY',
'KELBY',
'DANYA',
'ARIKA',
'WILMA',
'MISHA',
'LAVAR',
'JEVON',
'BJORN',
'ARLEN',
'TRANG',
'TARON',
'ROXIE',
'REENA',
'RAHUL',
'MAMIE',
'EMORY',
'AUTUM',
'ASLEY',
'ANWAR',
'RICKI',
'RHODA',
'PHONG',
'PATTI',
'ODELL',
'NIDIA',
'LAURI',
'KEYON',
'KEARA',
'JOREL',
'JERON',
'JAMIA',
'CALEY',
'STEVI',
'SAHAR',
'MERLE',
'JOSUA',
'JAREN',
'JACEY',
'HASAN',
'GORGE',
'ELLIE',
'EAMON',
'DOLLY',
'CHAKA',
'TYRUS',
'TAVIA',
'REGIS',
'LEXIE',
'JAYMI',
'JARID',
'FREDA',
'DAINA',
'BYRAN',
'SIERA',
'ROWDY',
'RISHI',
'QIANA',
'LAYNE',
'KARAH',
'JULES',
'JERID',
'HALIE',
'CARRI',
'THANH',
'RYLAN',
'NILES',
'NADER',
'MATEO',
'KAYLI',
'KASHA',
'JESSA',
'CAMIE',
'BLANE',
'BASIL',
'ALYCE',
'MILAN',
'MERCY',
'LEMAR',
'KEREN',
'KECIA',
'FRITZ',
'DARIA',
'CHINA',
'CAYCE',
'BONNY',
'AMMON',
'TWILA',
'TREVA',
'MEGEN',
'MARTI',
'LIZET',
'KUNAL',
'KAMIE',
'JUDAH',
'JODEE',
'JAVAN',
'JARET',
'JANEA',
'HAKIM',
'ASPEN',
'ZAHRA',
'WILLY',
'VERNA',
'NANCI',
'MIKAL',
'LANAE',
'KORIE',
'KENIA',
'JACKI',
'CHACE',
'TEILA',
'TEALA',
'TAVIS',
'SEANA',
'ROMEL',
'QUANG',
'POOJA',
'NILDA',
'NEVIN',
'LAINE',
'FREDY',
'FANNY',
'EVANS',
'ASHIA',
'AMBRA',
'AMADO',
'SHAIN',
'RONNI',
'NISSA',
'LUIGI',
'JAIMI',
'HUONG',
'GEMMA',
'DIONE',
'DIONA',
'CYRIL',
'CUONG',
'CODEY',
'CALLY',
'BORIS',
'BILAL',
'XENIA',
'TRUNG',
'TAIRA',
'SHYRA',
'MANNY',
'MAJOR',
'LEESA',
'KAMAL',
'JAYCE',
'DYANA',
'DASHA',
'BREON',
'ANAND',
'ALICA',
'VIJAY',
'TWYLA',
'TRUDY',
'TRENA',
'TONJA',
'TOBIN',
'TAMIA',
'SAIRA',
'ROHAN',
'MELIA',
'MARIN',
'LINDI',
'KWAME',
'FABIO',
'DARYN',
'BEVIN',
'ARASH',
'LESLY',
'KIETH',
'JANAY',
'IMRAN',
'GARET',
'DAWNA',
'DAREK',
'CHENG',
'TEARA',
'SUNNI',
'SLADE',
'RUBIN',
'RANAE',
'ORRIN',
'NUBIA',
'MAGDA',
'KALIA',
'IMANI',
'GENIE',
'EVITA',
'DWAIN',
'BERRY',
'AUDRY',
'AMIEE',
'YANCY',
'VELMA',
'OLLIE',
'NEKIA',
'LISHA',
'LEORA',
'LAURO',
'LAINA',
'KERRA',
'KARRA',
'JANEY',
'GERRI',
'DAIVD',
'DAIEL',
'BRYNA',
'ANGUS',
'AMEER',
'AMBAR',
'ALIDA',
'WOODY',
'TORRI',
'SUZIE',
'SUMER',
'RANIA',
'LELIA',
'LARAE',
'KORIN',
'KENAN',
'KANDY',
'HOSEA',
'HENRI',
'BOONE',
'SHADE',
'MIGEL',
'MICKY',
'LERON',
'KENDA',
'JULEE',
'GRAIG',
'ESSIE',
'EMILE',
'EMELY',
'DAMAR',
'CATIE',
'ARYEH',
'ARMEN',
'ZOILA',
'TORIE',
'SYBIL',
'RANCE',
'MECCA',
'MAEVE',
'LEENA',
'KELLE',
]

if (CONFIG.normalization) {
  WORDS.forEach((val, i) => (WORDS[i] = val.normalize(CONFIG.normalization)))
}

function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
}

if (CONFIG.shuffle) {
  shuffle(WORDS)
}
